/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlMyClientIDResponse
 */
export interface ControlMyClientIDResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlMyClientIDResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlMyClientIDResponse
     */
    org_id?: string;
}

/**
 * Check if a given object implements the ControlMyClientIDResponse interface.
 */
export function instanceOfControlMyClientIDResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlMyClientIDResponseFromJSON(json: any): ControlMyClientIDResponse {
    return ControlMyClientIDResponseFromJSONTyped(json, false);
}

export function ControlMyClientIDResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMyClientIDResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
    };
}

export function ControlMyClientIDResponseToJSON(value?: ControlMyClientIDResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'org_id': value.org_id,
    };
}

